import React from 'react';
import './Home.css';
import './Details.css';

function Loading() {
  return (
    <div className = "loading">
        <img src="https://iili.io/doYWCb.jpg" alt=""/>
    </div>
  )
}
export default Loading;